module.exports = __webpack_public_path__ + "static/media/irPanelIcon.c27430a8.svg";